export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8543.0f010c96.jpg";